import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Modal, Label, Input, Button } from "reactstrap";

// Formik Validation
import { Link, withRouter} from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import "../../assets/scss/custom/style.css";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import i18next from 'i18next';
import { formatCurrency, formatDate, formatNumber } from '../../Utils/formatters';


const Portfolio = () => {
  //meta title
  document.title = i18next.t('My_Portfolio PG document title');
  const { getRequest, postRequest } = useRequests();

  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};

  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    setAlertData((AlertData) => ({
      ...AlertData,
      variant: 'error',
      message: i18next.t('No claim available better'),
    }));
    resetAlertData();
    return false;
    
    validation1.setValues({
      ...validation1.values,
      ct_id: elementData.ct_id,
      currency: 'Euro'
    });
    setStandardModal1(true);
  }

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      ct_id: '',
      currency: 'Euro',
    },
    validationSchema: Yup.object({
      currency: Yup.string().required(i18next.t('Property_Detail PG Please select currency'))
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = i18next.t('Processing...');

        const jsonpar = JSON.stringify({
          ct_id: values.ct_id,
          currency: values.currency,
        });
        const res = await postRequest('claim-fund', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetPropertyInvestment();

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();
        
        submit1.disabled = false;
        submit1.textContent = i18next.t('Submit');

        setStandardModal1(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const handleClickCryptoBalanceRefresh = async () => {
    const res = await getRequest('crypto-data-refresh');
    if (res && res.code === 200) {
      handleLoadGetPropertyInvestment();

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'success',
        message: res.message,
      }));
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  const [TotalInvestment, setTotalInvestment] = React.useState({
		total_value: 0,
    total_value_token_price: 0,
    project_count: 0
	});
  const [TransactionTBody, setTransactionTBody] = React.useState('');
  const [TransactionCards, setTransactionCards] = React.useState('');
  
  const handleT1Body = async (tempData) => {
    // Sort by timestamp (newest first)
    const sortedData = [...tempData].sort((a, b) => b.time_stamp - a.time_stamp);
    
    let tempTBody = sortedData.map((element, index) => {
        let startDate = moment.unix(element.time_stamp);
        let endDate;

        switch (element.lock_in_period) {
            case 'year':
                endDate = startDate.clone().add(element.lock_in_period_no, 'years');
                break;
            case 'month':
                endDate = startDate.clone().add(element.lock_in_period_no, 'months');
                break;
            case 'day':
                endDate = startDate.clone().add(element.lock_in_period_no, 'days');
                break;
            default:
                endDate = startDate;
        }

        const isLockInPeriodOver = moment().isAfter(endDate);

        return (
          <tr key={index}>
            <td>
              <div>
                <strong>
                  {localStorage.getItem("I18N_LANGUAGE") === "eng" 
                    ? (element.property_name || '-') 
                    : (element.translated_property_name || element.property_name || '-')}
                </strong>
                <br />
                <small style={{ color: '#6c757d' }}>{formatDate(startDate)}</small>
              </div>
            </td>
            <td>{formatCurrency(parseFloat(element.value) * parseFloat(element.token_price))}</td>
            <td>{formatNumber(parseFloat(element.value))}</td>
            <td>
              {element.lock_in_period_no} {element.lock_in_period_no > 1 
                ? i18next.t(element.lock_in_period + 's') 
                : i18next.t(element.lock_in_period)}
            </td>
            <td style={{ width: '160px' }}>
              {element.is_claimed === 1 ? 
                <span className="font-size-14 badge bg-secondary rounded-pill badge-soft-success">
                  {i18next.t('Repaid')}
                </span> 
                : 
                <span className="font-size-14 badge bg-secondary rounded-pill badge-soft-warning">
                  {i18next.t('Active')}
                </span>
              }
            </td>
            <td>
              <a 
                href={`https://polygonscan.com/tx/${element.hash}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#007bff', textDecoration: 'none' }}
              >
                {i18next.t('Ver en Polygon')} <i className="mdi mdi-open-in-new" style={{ fontSize: '14px' }}></i>
              </a>
            </td>
          </tr>
        );
    });

    setTransactionTBody(tempTBody);
    
    // Mobile Cards
    let tempCards = sortedData.map((element, index) => {
        let startDate = moment.unix(element.time_stamp);
        
        return (
          <div key={index} style={{ 
            border: '1px solid #e9ecef', 
            borderRadius: '8px', 
            padding: '16px', 
            marginBottom: '12px',
            backgroundColor: '#fff'
          }}>
            {/* Line 1: Project name and amount */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
              <div style={{ flex: '1', paddingRight: '12px' }}>
                <strong style={{ fontSize: '15px', color: '#495057', lineHeight: '1.4', wordWrap: 'break-word' }}>
                  {localStorage.getItem("I18N_LANGUAGE") === "eng" 
                    ? (element.property_name || '-') 
                    : (element.translated_property_name || element.property_name || '-')}
                </strong>
              </div>
              <div style={{ fontWeight: '600', fontSize: '15px', color: '#495057', whiteSpace: 'nowrap' }}>
                {formatCurrency(parseFloat(element.value) * parseFloat(element.token_price))}
              </div>
            </div>
            
            {/* Line 2: Date, period, tokens */}
            <div style={{ fontSize: '13px', color: '#74788d', marginBottom: '12px' }}>
              {formatDate(startDate)} · {element.lock_in_period_no} {element.lock_in_period_no > 1 
                ? i18next.t(element.lock_in_period + 's') 
                : i18next.t(element.lock_in_period)} · {formatNumber(parseFloat(element.value))} tokens
            </div>
            
            {/* Line 3: Status badge and blockchain link */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                {element.is_claimed === 1 ? 
                  <span className="font-size-14 badge bg-secondary rounded-pill badge-soft-success">
                    {i18next.t('Repaid')}
                  </span> 
                  : 
                  <span className="font-size-14 badge bg-secondary rounded-pill badge-soft-warning">
                    {i18next.t('Active')}
                  </span>
                }
              </div>
              <div>
                <a 
                  href={`https://polygonscan.com/tx/${element.hash}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#007bff', textDecoration: 'none', fontSize: '14px' }}
                >
                  {i18next.t('Ver en Polygon')} <i className="mdi mdi-open-in-new" style={{ fontSize: '12px' }}></i>
                </a>
              </div>
            </div>
          </div>
        );
    });

    setTransactionCards(tempCards);
  }
  const handleLoadGetPropertyInvestment = async () => {
    const res = await getRequest('get-property-investment');
    if (res && res.code === 200) {
      handleT1Body(res.data.crypto_transaction);

      // Count unique projects
      const uniqueProjects = new Set(res.data.crypto_transaction.map(item => item.property_name || item.translated_property_name));
      
      setTotalInvestment({
        ...TotalInvestment,
        total_value: res.data.total_value,
        total_value_token_price: res.data.total_value_token_price,
        project_count: uniqueProjects.size
      });
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="6" className="text-center">{i18next.t('No records found')}</td>
                      </tr>);

      setTransactionTBody(tempTBody);
      setTransactionCards(
        <div style={{ textAlign: 'center', padding: '20px', color: '#74788d' }}>
          {i18next.t('No records found')}
        </div>
      );
    }
  }
  React.useEffect(() => {
    handleLoadGetPropertyInvestment();
  }, []);


  return (
    <React.Fragment>
      <style>{`
        @media (max-width: 600px) {
          .portfolio-desktop-table { display: none !important; }
          .portfolio-mobile-cards { display: block !important; }
        }
        @media (min-width: 601px) {
          .portfolio-desktop-table { display: block !important; }
          .portfolio-mobile-cards { display: none !important; }
        }
      `}</style>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content common-width">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={i18next.t('PG title Tokenizedgreen')} breadcrumbItem={i18next.t('PG breadcrumbItem My_Portfolio')} />
          <Row>
            <Col xs="12">
              <div className="sidebar">
                <ul>
                  <li><Link to="/dashboard"><i className="bx bx-home-circle"></i> {i18next.t('Menu Dashboard')}</Link></li>
                  {
                    localStorage.getItem("Collaborator")=="true"?
                    <li><Link to="/collaborator"><i className="fas fa-handshake"></i> {i18next.t('Collaborator')}</Link></li>
                    :''
                  }                  
                  <li><Link to="/wallet"><i className="bx bx-wallet-alt"></i> {i18next.t('Menu My Wallet')}</Link></li>
                  <li><Link to="/properties"><i className="bx bx-shopping-bag"></i> {i18next.t('Menu Browse Property')}</Link></li>
                  <li><Link to="/portfolio" className="active"><i className="bx bx-cart-alt"></i> {i18next.t('Menu My Portfolio')}</Link></li>
                  <li><Link to="/claimed-fund"><i className="bx bx-money"></i> {i18next.t('Menu My Claimed Fund')}</Link></li>
                  <li><Link to="/mytransaction"><i className="bx bx-list-ul"></i> {i18next.t('Menu My Transaction')}</Link></li>
                  <li><Link to="/Kyc"><i className="bx bx-user-check"></i> {i18next.t('Menu KYC Verification')}</Link></li>
                  <li><Link to="/twofaauthenticator"><i className="bx bx-key"></i> {i18next.t('Menu 2FA Authenticator')}</Link></li>
                  <li><Link to="/dividends"><i className="bx bx-wallet-alt"></i> {i18next.t('Menu Dividends')}</Link></li>
                </ul>
              </div>
              <div className="contentt">
                <Row>
                  <Col lg="12">
                    <Card>
                      <CardBody>
                        <div className="d-flex mobileFullWidth">
                          <div className="flex-grow-1 align-self-center">
                            <div className="text-muted">
                              <h5 className="fullWidth maticRefresh">
                                <span>{i18next.t('Active Investment')} - {formatCurrency(TotalInvestment.total_value_token_price)}</span>
                                <div className="font-size-24 text-primary send-receive" onClick={(e) => handleClickCryptoBalanceRefresh()}>
                                  <i className="mdi mdi-reload" />
                                </div>
                              </h5>
                              <p className="mb-1" style={{ fontSize: '14px', color: '#74788d' }}>
                                {formatNumber(TotalInvestment.total_value)} {i18next.t('tokens in')} {TotalInvestment.project_count} {TotalInvestment.project_count === 1 ? i18next.t('project') : i18next.t('projects')}
                              </p>
                            </div>
                          </div>
                          <div className="flex-grow-1 align-self-center">
                            <div className="InvestmentBtn">
                              <Link to="/properties" className="btn-sm btn btn-primary pad25">{i18next.t('Invest Now')}</Link>
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        {/* Desktop Table - visible above 600px */}
                        <div className="table-responsive portfolio-desktop-table">
                          <table className="table mb-0" style={{ minWidth: '1000px' }}>
                            <thead className="table-light">
                              <tr>
                                <th>{i18next.t('Project')}</th>
                                <th>{i18next.t('Your Investment')}</th>
                                <th>{i18next.t('Tokens')}</th>
                                <th>{i18next.t('Lock-In Period')}</th>
                                <th style={{ width: '160px' }}>{i18next.t('Status')}</th>
                                <th>{i18next.t('Blockchain')}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {TransactionTBody}
                            </tbody>
                          </table>
                        </div>
                        
                        {/* Mobile Cards - visible below 600px */}
                        <div className="portfolio-mobile-cards">
                          {TransactionCards}
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={StandardModal1} backdrop={'static'} centered className="transation" >
        <div className="modal-header">
          <h5 className="modal-title mt-0">{i18next.t('Claim Fund')}</h5>
          <button type="button" onClick={(e)=>setStandardModal1(false)} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="form-group cstm-select-country fullWidth mb-4">
            <div className="fullWidth">
              <select className="form-select" name="currency" value={validation1.values.currency} onChange={(e) => validation1.setValues({ ...validation1.values, currency: e.target.value })}>
                <option value="Euro">Euro</option>
              </select>
            </div>
          </div>
          <Label className="form-label note-lable note mb-0 mt-1"><b>{i18next.t('Note')}:</b> {i18next.t('My_Portfolio PG label')}<br/><br/>{i18next.t('My_Portfolio PG description')}</Label>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary"
            id="submit1"
            onClick={(e) => {
              e.preventDefault();
              validation1.handleSubmit();
              return false;
            }}
          >{i18next.t('Submit')}</button>
          <button type="button" className="btn btn-light" data-dismiss="modal" onClick={(e)=>setStandardModal1(false)} >{i18next.t('Close')}</button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(Portfolio);